import { AboutLayout } from "@/components/about-layout";
const SplitComponent = AboutLayout;
export { SplitComponent as component };